module.exports = __webpack_public_path__ + "img/black-logo.e6e1265a.svg";